<template>
  <div id="Aside">
    <div class="aside_box" :class="path[0]==''?'on':''">
      <div class="aside_list">
        <router-link :to="{name:'index'}">Overview</router-link>
      </div>
    </div>
    <div class="aside_box" :class="path[0]=='commodity'?'on':''">
      <div class="aside_list" :class="(path[1]!=null&&path[0]=='commodity')?'sub_list':''" @click="tabup('my_commodity')">
        <span class="more" :class="this.openCommodity == true ? 'click_box':''">My Commodity</span>
      </div>
      <!-- ul去掉 v-if="path[0]=='commodity'" -->
      <ul class="sub_ul" v-if="openCommodity">
        <li :class="path[1]=='New'?'on':''">
          <div class="sub_div">
            <router-link :to="{path:'/commodity/New'}">Add New ltem</router-link>
          </div>
        </li>
        <li :class="path[1]=='Draft'?'on':''">
          <div class="sub_div">
            <router-link :to="{path:'/commodity/Draft'}">Draft</router-link>
          </div>
        </li>
        <li :class="path[1]=='Active'?'on':''">
          <div class="sub_div Active_b" :class="[path[2]!=null?'sub_list':'', this.openActive == true ? 'click_box':'']" @click="tabup('Active')">
            <span>Active</span>
          </div>
          <!-- v-if="path[1]=='Active'" -->
          <div class="sub_two_list" v-if="openActive ">
            <div class="sub_div" :class="(path[2]!='Buy'&&path[1]=='Active')?'on':''">
              <router-link :to="{path:'/commodity/Active/Auction'}">Auction</router-link>
            </div>
            <div class="sub_div" :class="path[2]=='Buy'?'on':''">
              <router-link :to="{path:'/commodity/Active/Buy'}">Buy It Now</router-link>
            </div>
          </div>
        </li>
        <li :class="path[1]=='Scheduled'?'on':''">
          <div class="sub_div">
            <router-link :to="{path:'/commodity/Scheduled'}">Scheduled</router-link>
          </div>
        </li>
        <li :class="path[1]=='Unsold'?'on':''">
          <div class="sub_div">
            <router-link :to="{path:'/commodity/Unsold'}">Unsold</router-link>
          </div>
        </li>
        <li :class="path[1]=='Offer'?'on':''">
          <div class="sub_div">
            <router-link :to="{path:'/commodity/Offer'}">Offer</router-link>
          </div>
        </li>
      </ul>
    </div>
    <div class="aside_box" :class="path[0]=='orders'?'on':''">
      <div class="aside_list">
        <router-link :to="{name:'orders'}">My Orders</router-link>
      </div>
    </div>
    <!-- <div class="aside_box" :class="path[0]=='data'?'on':''">
      <div class="aside_list">
        <router-link :to="{name:'data'}">My Data</router-link>
      </div>
    </div> -->
    <div class="aside_box" :class="path[0]=='store'?'on':''">
      <div class="aside_list">
        <router-link :to="{name:'store'}">My Store</router-link>
      </div>
    </div>
    <div class="aside_box" :class="path[0]=='messages'?'on':''">
      <div class="aside_list">
        <router-link :to="{name:'messages'}">My Messages</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Aside',
  data() {
    return {
      openCommodity: true,
      openActive: false,
    }
  },
  props: {
    path: Array,
  },
  methods: {
    tabup(val) {
      if (val == 'my_commodity') {
        if (this.openCommodity == true) {
          this.openCommodity = false;
        }
        else {
          this.openCommodity = true;
        }
      }
      else if (val == 'Active') {
        if (this.openActive == false) {
          this.openActive = true;
        }
        else {
          this.openActive = false;
        }
      }
      else{
          this.openActive = false;
          this.openCommodity = false;
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../static/css/aside.css";
#Aside {
  padding: 10px 0;
  box-sizing: border-box;
  min-width: 240px;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/aside.vue